<template>
  <div class="page main">
    <template>
      <app-title :page="'Nimber'"><h2 slot="content">Play with your numbers</h2></app-title>
      <div class="grid">
        <p>{{ status }}</p>
        <section class="">
          <div id="firebase"/>
        </section>
      </div>
    </template>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import * as firebaseui from 'firebaseui'
import Title from './common/Title.vue'
import Loader from './svgs/Loader'
import { mapGetters } from 'vuex'

export default {
  components: {
    appTitle: Title,
    svgLoader: Loader
  },
  data () {
    return {
      status: ''
    }
  },
  computed: {
    ...mapGetters([
      'loading',
      'user'
    ])
  },
  mounted () {
    const dt = this
    const uiConfig = {
      signInSuccessUrl: '/loading',
      signInOptions: [
        firebase.default.auth.GoogleAuthProvider.PROVIDER_ID
      ],
      callbacks: {
        signInSuccessWithAuthResult: function (authResult, redirectUrl) {
          console.log('Redirect:')
          console.log(redirectUrl)
          dt.$store.dispatch('toggleLoading', true)
          if (redirectUrl) {
            dt.$store.dispatch('setRedirect', redirectUrl)
          }
          return true
        },
        uiShown: function () {
          dt.$store.dispatch('toggleLoading', false)
        }
      },
      signInFlow: 'popup'
    }
    let ui = firebaseui.auth.AuthUI.getInstance()
    if (!ui) {
      ui = new firebaseui.auth.AuthUI(firebase.auth())
    }
    ui.start('#firebase', uiConfig)
  }
}
</script>

<style>
  .firebaseui-title {
    font-size: var(--font-size-7);
  }
  .firebaseui-card-content input {
    font-size: var(--font-size-3);
    line-height: var(--line-height-3);
    padding: calc(var(--line) * 0.65);
    border-radius: var(--radius);
    margin-bottom: var(--line);
    max-width: 30em;
  }
  .firebaseui-card-actions {
    display: flex;
    align-items: baseline;
    justify-content: flex-start;
  }
  .firebaseui-form-links {
    font-size: var(--font-size-2);
    margin: 0 var(--line);
    order:3;
  }
  .firebaseui-card-actions button {
    margin-right: calc(var(--line) * 0.5);
    margin-bottom: calc(var(--line) * 0.5);

  }
  .firebaseui-id-secondary-link {
    background: transparent;
    color: var(--dark-red);
    font-weight: var(--bold);
    letter-spacing: 0;
  }
  .firebaseui-id-secondary-link:hover,
  .firebaseui-id-secondary-link:active,
  .firebaseui-id-secondary-link:focus {
    background: rgba(0, 0, 0, 0.1);
  }
  .firebaseui-id-submit {
    font-size: var(--font-size-3);
    padding: calc(var(--line) * 0.8) calc(var(--line) * 1.5) calc(var(--line) * 0.8) calc(var(--line) * 1.5);
  }
  .firebaseui-info-bar {
    font-size: var(--font-size-2);
    background: var(--dark-red);
    color: var(--cream);
    border-radius: var(--radius);
    padding: calc(var(--line) / 2);
    display: inline-block;
    margin: calc(var(--line) / 2) 0;
  }
  .firebaseui-info-bar p {
    margin: 0;
  }
  .firebaseui-info-bar a {
    color: var(--white);
  }
  .firebaseui-idp-list {
    list-style: none;
    margin:0;
  }
  .firebaseui-link {
    float:right;
  }
  .firebaseui-idp-icon-wrapper,
  img.firebaseui-idp-icon {
    width: 0.8em;
    margin-right: 0.25em;
  }
  .firebaseui-idp-button {
    padding: calc(var(--line) * 0.8) calc(var(--line) * 1.5) calc(var(--line) * 0.8) calc(var(--line) * 1.5);
  }
  button .firebaseui-idp-text {
    color: var(--black);
  }
  button .firebaseui-idp-text-short {
    display:none;
  }
  @-moz-keyframes spin {
    from { -moz-transform: rotate(0deg); }
    to { -moz-transform: rotate(360deg); }
  }
  @-webkit-keyframes spin {
    from { -webkit-transform: rotate(0deg); }
    to { -webkit-transform: rotate(360deg); }
  }
  @keyframes spin {
    from {transform:rotate(0deg);}
    to {transform:rotate(360deg);}
  }
  div.mdl-progress::after {
    display: block;
    content: url('../assets/loader.svg');
    text-align: center;
    background-size: cover;
    animation: spin 0.9s infinite ease-in-out;
    transform-origin: 50% 50%;
    width:80px;
    height: 80px;
  }
  .mdl-progress {
    position: fixed;
    background: var(--dark-grey);
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    z-index: 100;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  @media screen and (min-width: 48em) {
    .firebaseui-list-item {
      display: inline-block;
      margin-right: calc(var(--line) / 2);
    }
  }
</style>
